import React from 'react';
import PropTypes from 'prop-types';
import styled from "@emotion/styled";
import IconActionButton from "../common/IconActionButton";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";

const ComponentWrapper = styled.div`
    width: 100%;
    min-height: 119px;
    
    padding: 18px 16px;

    background: ${ props => !props.selected ? "white" : "#EEF2F6" };
    /* default/gray/300 */
    border: 1px solid #E3E8EF;
    box-sizing: border-box;
    border-radius: 8px;
    
    cursor: pointer;
    
    box-shadow: ${ props => props.collapsed
    ? "0px 2px 5px 0px rgba(0,0,0,0.07)"
    : props.selected 
    ? "0px 4px 6px rgba(0, 0, 0, 0.05), 0px 10px 15px rgba(0, 0, 0, 0.1)" 
    : (!props.seen)
    ? "0 2px 5px rgba(0, 0, 0, 0.12)"
    : "unset" }
`;

const HeadingGroup = styled.div`
    width: 100%;
    height: fit-content;
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const NotificationBody = styled.div`
    margin: 8px 0;
`;

const Seen = styled.div`
    width: 12px;
    height: 12px;
    margin-right: 8px;
    
    /* default/green/400 */
    background: #68D391;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(104, 211, 145, 0.3);
`;

const TimeCreatedWrapper = styled.span`
    font-family: Metropolis;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    /* identical to box height, or 100% */
    color: var(--color-gray-700);
`;

const AlertsCard = ({
    heading,
    body,
    timeCreated,
    seen,
    isSelected,
    collapsed,
    icon,
    onClose,
    onClick,
    }) =>
        <ComponentWrapper onClick={onClick} selected={isSelected} seen={seen} collapsed={collapsed}>
            <HeadingGroup>
                <div style={{display: "flex", flexDirection: "row"}}>
                    { !seen && <Seen/> }
                    <div>{icon}</div>
                    <span style={{marginLeft: "4px"}}>{heading}</span>
                </div>
                <span>
                    <TimeCreatedWrapper>{timeCreated}</TimeCreatedWrapper>
                    <IconButton size="small" onClick={onClose}>
                        <Icon fontSize="small">close</Icon>
                    </IconButton>
                </span>
            </HeadingGroup>

            <NotificationBody>
                {body}
            </NotificationBody>
        </ComponentWrapper>


AlertsCard.propTypes = {
    heading: PropTypes.string.isRequired,
    body: PropTypes.any.isRequired,
    timeCreated: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    isSelected: PropTypes.bool.isRequired,
    collapsed: PropTypes.bool.isRequired,
    seen: PropTypes.bool.isRequired,
    icon: PropTypes.any
};

AlertsCard.defaultProps = {
    heading: "",
    body: <div/>,
    timeCreated: Date(),
    isSelected: false,
    seen: false
};

export default AlertsCard;
